
export default {
  SHOW_ARCHIVED_LEADS: false,
  LEAD_ALERT_STATUS: true,
  LEAD_ALERT_CONTROL: false,
  SELECTED_LEADS: [],
  BULK_BUY: false,
  AVAILABILITY_CHECK: false,
  NOT_AVAILABLE: null,
  PRE_SELECT: false,
  PRE_SELECT_REJECT: null,
  ACTIVE_LEAD: null,
  LEAD_NOTIFICATIONS: {},
  ACTIONED_LEADS: [],
  ORIGIN: null,
  LEAD_NOTIFICATION_INTERVAL: null,
}
